<div *ngIf="this.isLoading" class="se-loader"></div>
<!-- Main Grid -->
<div class="main-div p-2">
  <div class="top-div">
    <div class="filter-sec">
      <input type="text" title={{labels.dgGroupSearch|translate}} aria-label="search" class="input-globalsearch" size="50" placeholder={{labels.search|translate}} (input)="dt.filterGlobal($event.target.value, 'contains')">
      <a class="SearchLink">
        <em class="fa fa-search SearchIcon"></em>
      </a>
      <button class="se-button btnAddGroup cursorPointerHand" (click)="OnAddGroup()">
        {{ labels.dgCreateGroupBtn | translate }}
      </button>
    </div>
  </div>
  <div class="tbl-section">
    <div class="rectangle-grid">
      <p-table #dt [columns]="groupsCols" [value]="deviceGroups" [paginator]="isPagination"
               [rows]="10" responsiveLayout="stack" [autoLayout]="true" [globalFilterFields]="['name','desc']">>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field">
              {{col.header | translate}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" class="box-shadow-none">
              {{ labels.dgTblHeaderActions | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr class="rowHeight">
            <td *ngFor="let col of columns" class="overflow-control" title="{{rowData[col.field]}}">
              <span *ngIf="col.field !== 'addedOn'">
                {{rowData[col.field]}}
              </span>
              <span *ngIf="col.field === 'addedOn'">
                {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm' }}
              </span>
            </td>
            <td>
              <img class="icon-action  iconShowGroupInfo info-icon" (click)="OnShowGroupInfo(rowData)" 
                (keydown)="OnShowGroupInfo(rowData)" (keypress)="OnShowGroupInfo(rowData)" 
                (keyup)="OnShowGroupInfo(rowData)" src="assets/info.svg" alt="info" height="29" width="30"/>
              <img class="icon-action iconEditGroup editIcon" (click)="OnEditGroup(rowData)" 
              (keydown)="OnEditGroup(rowData)" (keypress)="OnEditGroup(rowData)" 
              (keyup)="OnEditGroup(rowData)"  src="assets/edit.svg" alt="edit" height="21" width="21"/>
              <img class="icon-action iconDeleteGroup" (click)="OnDeleteGroup(rowData)" 
              (keydown)="OnDeleteGroup(rowData)" (keypress)="OnDeleteGroup(rowData)" 
              (keyup)="OnDeleteGroup(rowData)" src="assets/delete.svg" alt="delete" height="29" width="29"/>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr *ngIf="noDataGroups">
            <td [attr.colspan]="columns.length+1">
              {{labels.noRecords | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
</div>

<template ngbModalContainer>
</template>
<p-toast class="mt10" position="top-center" key="success"></p-toast>
<p-toast class="mt10" position="top-center" key="error"></p-toast>
<p-toast position="center" key="c" (onClose)="onRejectToast()" [baseZIndex]="5000"></p-toast>

<!-- Create/Edit Group Modal -->
<div class="se-dialog" *ngIf="showAddEditDialog">
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{ addEditModalHeader | translate}}</h3>
    </div>
    <div class="se-dialog-body">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      <div class="se-inline-form add-edit-group-frm">
        <div class="form-ele col-md-12">
          <label for="txtGroupName" class="se-label col-md-3 mt-2">{{labels.dgCreateAddGroupName | translate}}<span>*</span></label>
          <input id="txtGroupName" name="txtGroupName" placeholder="Group Name" autocomplete="off" type="text" appRequiredElementValidator class="se-form-control col-md-6 groupTextWidth" #groupName="ngModel" [(ngModel)]="txtGroupName" #GroupName (keyup)="ValidateForm()" [minLength]="1" [maxLength]="50">
          <div class="d-block brand-error se-fs-12" *ngIf="!groupName.errors?.requiredElementValidator && (groupName.dirty || groupName.touched)">
            {{ groupNameValErrMsg }}
          </div>
        </div>
        <div class="dg-select-device form-ele col-md-12">
          <label class="se-label col-md-3 mt-3">{{labels.dgCreateSelectDevices | translate}}<span>*</span></label>
          <p-multiSelect class="col-md-6 ml8" [options]="deviceDetails" [(ngModel)]="selectedDevices" placeholder="Select Devices"
                         optionLabel="name" display="chip" (onChange)="ValidateForm()"></p-multiSelect>
          <div class="d-block brand-error se-fs-12" *ngIf="!selectedDevices.valid">
            {{ selectDevicesErrValMsg }}
          </div>
        </div>
        <div class="form-ele col-md-12">
          <label for="desc" class="se-label col-md-3 mt-2">{{ labels.dgGroupAddEditDescLabel | translate }}</label>
          <textarea id="desc" name="desc" maxlength="1000" class="se-form-control col-md-6 txta-fix-height no-resize groupTextWidth" placeholder="Type your description" [(ngModel)]="txtGroupDesc" (keyup)="ValidateForm()"></textarea>
        </div>
      </div>
    </div>
    <div class="se-dialog-footer">
      <button class="se-button btnCancel" (click)="OnCancelAddEdit()">{{ labels.cancel | translate }}</button>
      <button class="se-button button-primary btnSave" [disabled]="formInvalid" [ngClass]="{ 'disabled-cls': formInvalid }" (click)="OnSaveOrEditGroup()">{{labels.saveAndApp | translate}}</button>
    </div>
  </div>
</div>

<!-- Group Info Modal -->
<div class="se-dialog" *ngIf="showInfoDialog">
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{ labels.dgGroupInfoModalHeader | translate}}</h3>
    </div>
    <div class="se-dialog-body">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      <div class="form-ele ml-3 text-left">
        <label for="txtGrpName" class="se-label mt-2 mr-3">{{ labels.dgTblHeaderGroupName | translate }}</label>
        <input id="txtGrpName" type="text" disabled="" class="se-form-control" placeholder="{{ currentGroup.name }}">
      </div>
      <div class="text-left">
        <div class="filter-sec-ginfo pt-2">
          <input type="text" title={{labels.dgGroupSearch|translate}} aria-label="search" class="input-globalsearch " size="50" placeholder={{labels.search|translate}} (input)="dt.filterGlobal($event.target.value, 'contains')">
          <a class="SearchLink icon-search-devicegrp">
            <em class="fa fa-search SearchIcon"></em>
          </a>
        </div>
      </div>
      <div class="col-12 pt-3">
        <p-table #dt [columns]="groupInfoCols" [value]="deviceGroupInfo" [paginator]="isGrpInfoPagination" [rows]="5" responsiveLayout="stack" [autoLayout]="true"
                 [globalFilterFields]="['name']">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field">
                <span *ngIf="col.field !== 'isActive'">
                  {{col.header | translate}}
                </span>
                <span scope="col" *ngIf="col.field === 'isActive'">
                  {{ labels.tableHeaderDeviceStatus | translate}}
                </span>

                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr class="rowHeight">
              <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                <span *ngIf="col.field !== 'deviceStatus' && col.field !== 'lastConnectedOn'">
                  {{rowData[col.field]}}
                </span>
                <span *ngIf="col.field === 'deviceStatus'">
                  {{ rowData[col.field] === 0 ? labels.offline :(rowData[col.field] === 1? labels.online :labels.tableDataDeviceInActive ) }}
                </span>
                <span *ngIf="col.field === 'lastConnectedOn'">
                  {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm' }}
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr *ngIf="noDataGroupInfo">
              <td [attr.colspan]="columns.length+1">
                {{labels.noRecords | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="se-dialog-footer">
      <button class="se-button btnClose" (click)="OnCloseGroupInfo()">{{ labels.close | translate }}</button>
    </div>
  </div>
</div>

<!-- Delete Group Modal -->
<div class="se-dialog" *ngIf="showDeleteModal">
  <div class="se-dialog-holder">
    <div class="se-complex-header se-warning">
      <h3 class="se-dialiog-title">{{ currentGroup.name }}</h3>
    </div>
    <div class="se-dialog-body se-dialog-body-delete">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      {{ messages.deleteDevice | translate }}
    </div>
    <div class="se-dialog-footer">
      <button class="se-button btnNo" (click)="OnGroupDeleteReject()">{{ labels.no | translate}}</button>
      <button class="se-button btnYes " (click)="OnGroupDeleteConfirm()">{{ labels.yes | translate}}</button>
    </div>
  </div>
</div>
